import axios from 'axios'
import index from "@/core/services/store/index"
import {AxiosRedirect} from "../axios.redirect";

let _URL = AxiosRedirect()

export default () => {

    let TokenInfo = JSON.parse(JSON.stringify(index.getters.getToken))
    let ax = axios.create({
        baseURL: _URL.apiURL,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
            "Authorization": `Bearer ${TokenInfo.access_token}`,
        }
    })
    ax.interceptors.response.use((response) => {
        return response
    }, (error) => {
        return error.response
    })
    return ax
}
